export const removeNewLines = (text) => {
  return text.replace(/\n{3,}/gi, '\n\n');
};

export function camelToUnderscore(key) {
  return key.replace(/([A-Z])/g, '_$1').toLowerCase();
}
